import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	customerOrganization: {
		id: 'servicedesk-request-type-security.services.search-principals.customer-organization',
		defaultMessage: 'Customer organization',
		description: 'Byline for customer organization',
	},
	group: {
		id: 'servicedesk-request-type-security.services.search-principals.group',
		defaultMessage: 'Group',
		description: 'Byline for user group',
	},
});
